import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  ARCHIVE_CHECK_TYPES,
  CREATE_CHECK_TYPES,
  DELETE_CHECK_TYPES, EDIT_CHECK_TYPES_BY_ID, EDIT_FILE_EXPORT_BY_ID,
  EDIT_MAIS_EGU_BY_ID, EXPORT_MAIS_EGU_BY_ID, LOAD_CHECK_TYPES_BY_ID,
  LOAD_CHECK_TYPES_LIST, LOAD_CHECKS_BY_ID, LOAD_CHECKS_LIST, LOAD_FILE_EXPORT_BY_ID, LOAD_FILE_EXPORT_LIST,
  LOAD_MAIS_EGU_BY_ID,
  LOAD_MAIS_EGU_LIST,
  LOAD_MAIS_EGU_LOGS_LIST,
  UNARCHIVE_CHECK_TYPES,
} from './actions';
import { INTEGRATION_MODULE } from '../../configs/moduleNames';
import {
  createLoadByIdReducer,
  createLoadListReducer,
  createLoadListReducerWithBegin,
  createOperationStateReducer,
} from '../../utils/getCrudConfig';

const initialState = {
  maisEguListMeta: {},
  loadingMaisEguList: false,
  maisEguList: [],
  loadingCurrentMaisEgu: false,
  currentMaisEgu: {},
  maisEguLogsListMeta: {},
  loadingMaisEguLogsList: false,
  maisEguLogsList: [],
  checkTypesListMeta: {},
  loadingCheckTypesList: false,
  checkTypesList: [],
  loadingCurrentCheckTypes: false,
  currentCheckTypes: {},
  loadingEditCheckTypes: false,
  loadingArchiveCheckTypes: false,
  loadingUnarchiveCheckTypes: false,
  loadingDeleteCheckTypes: false,
  loadingCreateCheckTypes: false,
  checksListMeta: {},
  loadingChecksList: false,
  checksList: [],
  loadingCurrentChecks: false,
  currentChecks: {},
  fileExportListMeta: {},
  loadingFileExportList: false,
  fileExportList: [],
  loadingCurrentFileExport: false,
  currentFileExport: {},
  loadingEditFileExport: false,
  loadingExportMaisEguById: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(INTEGRATION_MODULE + LOAD_MAIS_EGU_LIST, 'maisEguList', 'loadingMaisEguList'),
  ...createLoadByIdReducer(INTEGRATION_MODULE + LOAD_MAIS_EGU_BY_ID, 'currentMaisEgu', 'loadingCurrentMaisEgu'),
  ...createOperationStateReducer(INTEGRATION_MODULE + EDIT_MAIS_EGU_BY_ID, 'loadingEditMaisEgu'),
  ...createOperationStateReducer(INTEGRATION_MODULE + EXPORT_MAIS_EGU_BY_ID, 'loadingExportMaisEguById'),
  ...createLoadListReducer(INTEGRATION_MODULE + LOAD_MAIS_EGU_LOGS_LIST, 'maisEguLogsList', 'loadingMaisEguLogsList'),
  ...createLoadListReducerWithBegin(INTEGRATION_MODULE + LOAD_CHECK_TYPES_LIST, 'checkTypesList', 'loadingCheckTypesList'),
  ...createLoadByIdReducer(INTEGRATION_MODULE + LOAD_CHECK_TYPES_BY_ID, 'currentCheckTypes', 'loadingCurrentCheckTypes'),
  ...createOperationStateReducer(INTEGRATION_MODULE + EDIT_CHECK_TYPES_BY_ID, 'loadingEditCheckTypes'),
  ...createOperationStateReducer(INTEGRATION_MODULE + ARCHIVE_CHECK_TYPES, 'loadingArchiveCheckTypes'),
  ...createOperationStateReducer(INTEGRATION_MODULE + UNARCHIVE_CHECK_TYPES, 'loadingUnarchiveCheckTypes'),
  ...createOperationStateReducer(INTEGRATION_MODULE + DELETE_CHECK_TYPES, 'loadingDeleteCheckTypes'),
  ...createOperationStateReducer(INTEGRATION_MODULE + CREATE_CHECK_TYPES, 'loadingCreateCheckTypes'),
  ...createLoadListReducerWithBegin(INTEGRATION_MODULE + LOAD_CHECKS_LIST, 'checksList', 'loadingChecksList'),
  ...createLoadByIdReducer(INTEGRATION_MODULE + LOAD_CHECKS_BY_ID, 'currentChecks', 'loadingCurrentChecks'),
  ...createLoadListReducer(INTEGRATION_MODULE + LOAD_FILE_EXPORT_LIST, 'fileExportList', 'loadingFileExportList'),
  ...createLoadByIdReducer(INTEGRATION_MODULE + LOAD_FILE_EXPORT_BY_ID, 'currentFileExport', 'loadingCurrentFileExport'),
  ...createOperationStateReducer(INTEGRATION_MODULE + EDIT_FILE_EXPORT_BY_ID, 'loadingEditFileExport'),
}, initialState);

export default reducer;

export const getIntegrationData = createSelector(
  [state => state[INTEGRATION_MODULE]],
  state => {
    const {
      maisEguListMeta,
      loadingMaisEguList,
      maisEguList,
      loadingCurrentMaisEgu,
      currentMaisEgu,
      loadingEditMaisEgu,
      maisEguLogsListMeta,
      loadingMaisEguLogsList,
      maisEguLogsList,
      checkTypesListMeta,
      loadingCheckTypesList,
      checkTypesList,
      loadingCurrentCheckTypes,
      currentCheckTypes,
      loadingEditCheckTypes,
      loadingArchiveCheckTypes,
      loadingUnarchiveCheckTypes,
      loadingDeleteCheckTypes,
      loadingCreateCheckTypes,
      checksListMeta,
      loadingChecksList,
      checksList,
      loadingCurrentChecks,
      currentChecks,
      fileExportListMeta,
      loadingFileExportList,
      fileExportList,
      loadingCurrentFileExport,
      currentFileExport,
      loadingExportMaisEguById,
    } = state;
    return {
      maisEguListMeta,
      loadingMaisEguList,
      maisEguList,
      loadingCurrentMaisEgu,
      currentMaisEgu,
      loadingEditMaisEgu,
      maisEguLogsListMeta,
      loadingMaisEguLogsList,
      maisEguLogsList,
      checkTypesListMeta,
      loadingCheckTypesList,
      checkTypesList,
      loadingCurrentCheckTypes,
      currentCheckTypes,
      loadingEditCheckTypes,
      loadingArchiveCheckTypes,
      loadingUnarchiveCheckTypes,
      loadingDeleteCheckTypes,
      loadingCreateCheckTypes,
      checksListMeta,
      loadingChecksList,
      checksList,
      loadingCurrentChecks,
      currentChecks,
      fileExportListMeta,
      loadingFileExportList,
      fileExportList,
      loadingCurrentFileExport,
      currentFileExport,
      loadingExportMaisEguById,
    };
  },
);
